import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";

@Injectable({
    providedIn: 'root'
  })
  export class IdentifierService {
    constructor(private http: HttpService) { }
    getData(option,callback?:any){
        this.http.makeHttpRequest(option).subscribe(res => {
            if (res != undefined) {
                console.log(res," ghh ghv nhh");
              //this.setLinkedAccounts(res);
              callback(res['details']);
            }
          });
    }
  }